import { RepositoryFactory } from "repository/RepositoryFactory";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const getWallet = (userId) => async (dispatch) => {
  try {
    const unsubscribe = firebase
      .firestore()
      .collection("wallet")
      .where("userId", "==", userId)
      .onSnapshot((snapshot) => {
        const walletData = [];
        snapshot.forEach((doc) => {
          walletData.push({ id: doc.id, ...doc.data() });
        });
        dispatch({ type: "FETCH_WALLET", payload: walletData[0] });
      });
    return unsubscribe;
  } catch (error) {
    console.error(error);
  }
};

export const getWalletLog =
  (userId, lastDocument, onSuccess) => async (dispatch) => {
    try {
      let querya = await firebase
        .firestore()
        .collection("wallet_logs")
        .where("userId", "==", userId)
        .orderBy("createdAt", "desc");
      if (lastDocument != "") {
        querya = querya.startAfter(lastDocument);
      }
      querya
        .limit(5)
        .get()
        .then(async (query) => {
          let temp_data = [];
          for (const doc of query.docs) {
            const docData = doc.data();
            temp_data.push({
              id: doc.id,
              ...docData,
            });
          }

          dispatch({
            type: lastDocument ? "FETCH_WALLET_LOGS_MORE" : "FETCH_WALLET_LOGS",
            payload: {
              data: temp_data,
              lastDocument: query.docs[temp_data.length - 1],
              hasMoreDocument: temp_data.length >= 5,
            },
          });
          onSuccess();
        });
    } catch (error) {
      console.error(error);
    }
  };

export const IsLoader = (val) => async (dispatch) => {
  dispatch({
    type: "SET_IS_LOADING",
    payload: val,
  });
};

export const withdrawRequest =
  (amount, userId, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const withdrawRepository = RepositoryFactory.get("setWithdraw");
      await withdrawRepository.setWithdraw({ amount, userId });
      onComplete();
      toast.success("Withdrawl request sucessfully");
    } catch (error) {
      console.error(error.message);
    }
  };
